module.exports = __webpack_public_path__ + "static/media/success-tickets.96bfcbf1.svg";